class SignUpPresenter {
  constructor(view, signUpUseCase, updateObjectUseCase) {
    this.view = view;
    this.signUpUseCase = signUpUseCase;
    this.updateObjectUseCase = updateObjectUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  async submit() {
    const isWalkIn = this.view.props.params.isWalkIn;
    const { email, password, confirmPassword, ...others } = this.change;

    if (password !== confirmPassword) {
      this.view.showError("Password must be the same");
      return;
    }
    const user = {
      username: email,
      email,
      password,
      roles: [
        {
          id: "Applicants",
        },
      ],
      acl: {
        read: ["*"],
        write: ["*"],
      },
      ...others,
    };
    this.view.showProgress();
    try {
      this.view.showProgress();
      await this.signUpUseCase.execute(user);
      this.view.hideProgress();

      await this.view.showSuccess(
        "Congratulations, your account has been successfully created."
      );

      const redirectPath = isWalkIn === "true" ? "/signin/true" : "/signin";
      this.view.navigateTo(redirectPath);
    } catch (error) {
      this.view.hideProgress();
      const message =
        typeof error === "string"
          ? error
          : error.message || "An error occurred.";
      this.view.showError(message);
    }
  }
}

export default SignUpPresenter;
